import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { sortMenuByLabel } from "../../../../Helpers/sortMenuByLabel";
import { GetAllWorkSchdule } from "../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi"; // API action to fetch all work schedules
import { sidebarContractorOptionsEnum } from "../../../../enums/sidebarContractorOptionsEnum"; // Enum for sidebar options mapping
import routes from "../../../../Routes/routes"; // Application route definitions
import { STATUS_MODEL } from "../../../../enums/statusEnum";
import {IconsSideBar} from "./IconsSideBar";
import {MENU_NAME_MODEL} from "../../../LoginOption/Model/Model"; // Enum for user status

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Component responsible for handling contractor tab menu logic
const ContractorTabsApp = ({ currentUrl, setChangeStyle, parts, user, dispatch }) => {
    // Extract the module part of the URL to determine the current section
    const modulePart = parts[3] ? parts[3] : '';
    const { t } = useTranslation();

    // useEffect to dispatch the action to get all work schedules when the component mounts
    useEffect(() => {
        dispatch(GetAllWorkSchdule());
    }, []);

    // useEffect to update the sidebar style based on the current module in the URL
    useEffect(() => {
        setChangeStyle(sidebarContractorOptionsEnum[modulePart]);
    }, [currentUrl]);

    // Define the menu items for the contractor sidebar
    const menuItems = [
        {
            name: MENU_NAME_MODEL.EMPLOYEES,
            url: routes.contractor.searchEmployee,
            label: 'employees',
            onlyName: true,
            icon: IconsSideBar.icEmployees,
            isHovering: 2,
            hasPermission: true
        },
        {
            name: MENU_NAME_MODEL.VEHICLES,
            url: routes.vehicleContractor.search,
            label: 'vehicle_fleet',
            onlyName: true,
            icon: IconsSideBar.icVehicleFleet,
            isHovering: 3,
            hasPermission: true
        },
        {
            name: MENU_NAME_MODEL.CONTRACTS,
            url: routes.contractor.contractList,
            label: 'contracts',
            onlyName: true,
            icon: IconsSideBar.icContractors,
            isHovering: 6,
            hasPermission: true,
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: MENU_NAME_MODEL.PROFILE,
            url: routes.profile.contractor,
            label: 'profile',
            onlyName: true,
            icon: IconsSideBar.icProfile,
            isHovering: 5,
            hasPermission: true,
        },
        {
            name: MENU_NAME_MODEL.ACCESS_RIGHTS,
            url: routes.accessRights.list,
            label: 'ACCESS_RIGHTS',
            onlyName: true,
            icon: IconsSideBar.icAccess,
            isHovering: 6,
            hasPermission: true,
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: MENU_NAME_MODEL.FOODIE_DINING,
            url: routes.contractor.foodie,
            label: 'foodie_dining',
            onlyName: true,
            icon: IconsSideBar.icCafeteria,
            isHovering: 7,
            hasPermission: true,
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: MENU_NAME_MODEL.COMPANY_DOCUMENTATION,
            url: routes.contractor.companyDocumentation,
            label: 'company_documentation',
            onlyName: true,
            icon: IconsSideBar.icCompanyDocumentation,
            isHovering: 8,
            hasPermission: true
        },
        {
            name: MENU_NAME_MODEL.EQUIPMENT_MATERIAL_CONTROL,
            url: routes.equipmentAndMaterial.list,
            label: 'equipment_material_control',
            onlyName: true,
            icon: IconsSideBar.icEquipmentMaterial,
            isHovering: 9,
            hasPermission: true,
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
    ];

    // Return the menu items ascending by the label shown in the active language
    return {
        menuItems: sortMenuByLabel(menuItems, (item) => t(item.label))
    };
}

export default ContractorTabsApp; // Export the component so it can be used in other parts of the application
